import styled from '@emotion/styled';
import Box from '@mui/material/Box';

export const PinWrapper = styled(Box)`
  #pin > iframe {
    height: 40px;
    width: 100%;
  }
`;
